module.exports = ['dimension_range', 'medium', 'price_range', 'total']
